<ion-tabs>
  <ion-tab-bar slot="bottom">
    @for (tab of tabs; track trackByTabId($index, tab)) {
    <ion-tab-button [tab]="tab.id" [routerLink]="[tab.id]">
      <ion-icon [src]="tab.icon" />
      <ion-label>{{ tab.labelKey | translate }}</ion-label>
    </ion-tab-button>
    }
  </ion-tab-bar>
</ion-tabs>
